let _instance = null;

export class LevelEditorCandyHelper {
  /**
   * get singleton instance
   */
  static getInstance() {
    if (_instance === null) {
      _instance = new LevelEditorCandyHelper();
    }
    return _instance;
  }

  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * loop through available specials for a candy
   * @param {G.Candy} candy
   */
  loopThroughSpecials(candy) {
    const allSpecials = G.Helpers.candyDataMgr.getSpecialTypesWithTag('natural');
    const index = allSpecials.indexOf(allSpecials.find((specialType) => specialType.name === candy.getSpecialType())) + 1;
    if (allSpecials[index]) {
      candy.clearSpecialType();
      candy.setSpecialType(allSpecials[index], true);
    } else {
      candy.clearSpecialType();
    }
  }
}
